<template lang="html" src="./Divers.html" />

<script>
import { useStore } from "@/store/store.js"
import Modal from "@/components/modal-maps/modal.component.vue";
import mixins from "@/Mixins.js";

export default {
  name: "medicine",
  mixins: [mixins],
  components: {
    Modal
  },
  data: () => ({
    patient_id: "",
    medicine_name: "",
    medicine: true,
    filterLab: [],
    selected: [],
    medicamentos_divers: [],
    labs: [],
    addres: [],
    cep: "",
    options: false,
    typeSearch: "med",
    address: "",
    lat: "",
    lng: "",
    errorStr: "",
    gettingLocation: false,
    order: "ASC",
    order_distance: 250,
    show_input_cep: false,
    transitionName: "fade",
    farmacias: [],
    configs: {
      orderBy: "preco",
      order: "asc",
      filter: ""
    },
    bodyParameters: {},
    invalidFields: {
      search: false
    },
    notFound: false
  }),
  setup () {
    const store = useStore()

    return {
      getGoogleAddress: (cep) => store.dispatch("getGoogleAddress", cep),
      getAddressByZipcode: (cep) => store.dispatch("getAddressByZipcode", cep),
    }
  },
  mounted: function () {
    const vm = this;

    vm.patient_id = vm.$session.get("id");
    vm.getGeolocation();
    vm.getAddressDivers();
    vm.getLabs();

  },
  watch: {
    typeSearch: function(){
      const vm = this;
      vm.invalidFields.search = vm.validateSearch();
    }
  },

  methods: {
    async searchAddress() {
      const response = await this.getAddressByZipcode(this.cep)

      if (response) {
        const { street, neighborhood, city, state } = response.address
        this.address = `${street}, ${neighborhood} - ${city} / ${state}`
      } else {
        this.address = ""
      }
    },
    getLabs() {
      const vm = this;
      this.axios
        .post(
          `${vm.$store.state.filooServer}orizon/labs/`,
          (vm.bodyParameters = {
            pagInicio: null,
            qtdePagina: 1000
          })
        )
        .then(response => {
          vm.labs = response.data;
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },
    getGeolocation() {
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocalização não está habilitada."
      } else {
        this.gettingLocation = true
        navigator.geolocation.getCurrentPosition(
          async ({ coords }) => {
            this.$vs.loading()
            this.gettingLocation = false
  
            if (coords && coords.latitude && coords.longitude) {
              const response = await this.getGoogleAddress({
                lat: coords.latitude,
                lng: coords.longitude,
              })
  
              if (response) {
                this.address = await response.formatted_address
                this.cep = await response.address_components
                  .find((addr) => (addr.types.includes("postal_code")))
                  .short_name
              }
            }
          }
        )
      }
    },
    getAddressDivers() {
      const vm = this;
      vm.$vs.loading();

      this.axios
        .get(`${vm.$store.state.filooServer}orizon/address/${vm.patient_id}`)
        .then(response => {
          vm.addres = response.data[0];
          vm.cep = vm.addres.zipcode;
          vm.searchAddress();
          vm.getMedicineDivers();
        })
        .finally(() => {
          vm.$vs.loading.close();
        });
    },
    getMedicineDivers() {
      const vm = this;
      this.medicamentos_divers = [];
      this.filterLab = [];
      vm.validateSearch(vm.typeSearch);
      if (!vm.invalidFields.search) {
        var lat;
        var lng;
        if (this.cep != "") {
          lat = this.lat;
          lng = this.lng;
        } else {
          lat = this.lat;
          lng = this.lng;
        }
        if (this.typeSearch == "med") {
          vm.$vs.loading();
          this.axios
            .post(
              `${this.$store.state.filooServer}orizon/medicines`,
              (this.bodyParameters = {
                searchKey: this.medicine_name,
                searchParameter: 'nomeMedicamento',
                latitude: lat,
                longitude: lng,
                pageInitial: 1
              })
            )
            .then(response => {
              vm.notFound = false;
              vm.medicamentos_divers = response.data;
            })
            .catch(() => {
              vm.notFound = true;
            })
            .finally(() => {
              this.$vs.loading.close();
            });
        } else if (this.typeSearch == "lab") {
          this.filterLab = this.labs.filter(el => {
            return el.nome.includes(this.medicine_name.toUpperCase());
          });
          vm.notFound = vm.filterLab.length === 0;
        } else if (vm.typeSearch == "pri") {
          vm.$vs.loading();
          this.axios
            .post(
              `${vm.$store.state.filooServer}orizon/medicines`,
              (vm.bodyParameters = {
                searchKey: vm.medicine_name.toUpperCase(),
                searchParameter: 'principioAtivo',
                latitude: lat,
                longitude: lng,
                pageInitial: 1
              })
            )
            .then(response => {
              vm.notFound = false;
              vm.medicamentos_divers = response.data;
            })
            .catch(() => {
              vm.notFound = true;
            })
            .finally(() => {
              vm.$vs.loading.close();
            });
        }
      }
    },

    getLatLng() {
      const vm = this;
      if (vm.cep) {
        vm.$vs.loading();
        this.axios
          .get(
            "https://maps.googleapis.com/maps/api/geocode/json?address=" +
            vm.cep +
            "&key=AIzaSyAdwxi7P7SUDsbcxa3RRcQ315FDIOh1log"
          )
          .then(response => {
            vm.lat = JSON.stringify(
              response["data"].results[0].geometry.location.lat
            );
            vm.lng = JSON.stringify(
              response["data"].results[0].geometry.location.lng
            );
            vm.getPharmacy();
          });
      } else {
        vm.getPharmacy();
      }
    },

    replaceSpecialChars(str) {
      if (!str) return "";
      str = str.toLowerCase();
      var mapaAcentosHex = {
        a: /[\xE0-\xE6]/g,
        e: /[\xE8-\xEB]/g,
        i: /[\xEC-\xEF]/g,
        o: /[\xF2-\xF6]/g,
        u: /[\xF9-\xFC]/g,
        c: /\xE7/g,
        n: /\xF1/g
      };
      for (var letra in mapaAcentosHex) {
        var expressaoRegular = mapaAcentosHex[letra];
        str = str.replace(expressaoRegular, letra);
      }
      str = str.toUpperCase();
      return str;
    },

    maskMoney(value) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2
      });
      var newValue = parseFloat(value);
      var newValueFormat = formatter.format(newValue);
      return newValueFormat;
    },
    sortPharmacy(index) {
      var pharma = this.farmacias[index];
      pharma.medicamentos.sort(
        function (a, b) {
          if (this.order === "ASC") {
            return a.preco == b.preco ? 0 : a.preco > b.preco ? 1 : -1;
          } else if (this.order === "DESC") {
            return a.preco == b.preco ? 0 : a.preco < b.preco ? 1 : -1;
          }
        }.bind(this)
      );
    },
    validateSearch() {
      const vm = this;
      vm.invalidFields.search = vm.typeSearch !== "lab" && vm.testNullUndefinedEmpty(vm.medicine_name);
    }
  }
};
</script>

<style lang="scss" src="./Divers.scss" />
